import { createRouter, createWebHashHistory } from 'vue-router'
//import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'; 
import GardeView from '../views/GardeView.vue'; 
import FooterVue from '../views/BasPage.vue'; 
import DashboardView from '../views/DashboardView.vue'; 
import CoursView from '../views/CoursView.vue'; 
import CalendarView from '../views/CalendarView.vue'; 
import DateView from '../views/DateView.vue'; 
import EvaluationView from '../views/EvaluationView.vue'; 
import DoughnutChart from '../views/DoughnutChart.vue'; 
import adminView from '../views/adminView.vue'; 
import DashView from '../views/DashView.vue'; 
import StudentView from '../views/StudentView.vue'; 
import StudyView from '../views/StudyView.vue'; 
import EventView from '../views/EventView.vue'; 
import NoteView from '../views/NoteView.vue'; 

import NavView from '../views/NavView.vue'; 


const routes = [
  {
    path: '/',
    name: 'home',
    component: GardeView
  },

  {
    path: '/nav',
    name: 'nav',
    component: NavView
  },

  {
    path: '/student',
    name: 'student',
    component: StudentView
  },

  {
    path: '/note',
    name: 'note',
    component: NoteView
  },

  {
    path: '/event',
    name: 'event',
    component: EventView
  },

  {
    path: '/study',
    name: 'study',
    component: StudyView
  },

  {
    path: '/login',
    name: 'log',
    component: LoginView
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView
  },


   {
    path: '/dash',
    name: 'DashView',
    component: DashView
  },

  {
    path: '/cours',
    name: 'Cours',
    component: CoursView
  },

  {
    path: '/calendar',
    name: 'Calendar',
    component: CalendarView
  },

  {
    path: '/eval',
    name: 'Evaluation',
    component: EvaluationView
  },


  {
    path: '/DateView',
    name: 'DateView',
    component: DateView
  },

   {
    path: '/admin',
    name: 'adminView',
    component: adminView
  },


  {
    path: '/DoughnutChart',
    name: 'Donut',
    component: DoughnutChart
  },

  
  {
    path: '/FooterVue',
    name: 'FooterVue',
    component: FooterVue
  },

 
 



 
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
